import {Component, Input, OnInit} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {LanguageRestService} from '../../services/common/language-rest.service';
import {SelectItem} from 'primeng/api';

@Component({
  selector: 'wsd-select-languages-ac',
  templateUrl: './select-languages-ac.component.html',
  styleUrls: ['./select-languages-ac.component.css']
})
export class SelectLanguagesAcComponent implements OnInit {

  @Input()
  parentForm: UntypedFormGroup;

  @Input()
  label: string = 'WS_DIRECTORY.PERSON_MODIFY.LANGUAGES';

  @Input()
  controlName: string = 'languages';

  languages: SelectItem[];

  @Input()
  showLabel: boolean = true;

  constructor(private languageService: LanguageRestService) { }

  ngOnInit() {
    this.languageService.findAllLanguages().subscribe(data => {
      this.languages = data.map(value => {
        return {label: value.name, value};
      });
    });
  }
}
